import { createFileRoute, useRouter } from '@tanstack/react-router'
import { motion } from 'framer-motion'
import styles from './styles.module.scss'
import { LatestWinnerRow } from '@/components/desktop/latest-winners-row'
import { cardsServiceInstance } from '@/services/cards.service'
import { useCallback } from 'react'

export const Route = createFileRoute('/desktop/__app/home/')({
  component: RouteComponent,
  loader: async () => {
    const [winners, mePendingCards] = await Promise.all([
      cardsServiceInstance.winners(),
      cardsServiceInstance.mePending(),
    ])
    return {
      winners,
      mePendingCards
    }
  },
  shouldReload: true,
})

function RouteComponent() {
  const { winners, mePendingCards } = Route.useLoaderData()
  const router = useRouter()

  const navigate = useCallback(() => {
    if (mePendingCards > 0) {
      router.navigate({
        to: '/desktop/game'
      })
      return
    }

    router.navigate({
      to: "/desktop/buy"
    })
  }, [mePendingCards])

  return (
    <div className={styles.container}>
      <div className={styles.section_play}>
        <img
          src="/assets/home_img.png"
        />
        <button
          onClick={navigate}
        >
          <img
            src="/assets/btn_play.png"
          />
        </button>
      </div>
      <div className={styles.section__winners}>
        <img
          src="/assets/winners_desk.png"
        />
        <div>
          <motion.ul
            animate={{
              y: ['0%', '-50%'],
              transition: {
                y: {
                  repeat: Infinity,
                  repeatType: 'loop',
                  duration: 10,
                  ease: 'linear',
                },
              },
            }}
            className={styles.list_winners}
          >
            {
              winners.map((w, idx) => (
                <LatestWinnerRow
                  phoneNumber={w.phoneNumber}
                  username={w.username}
                  value={w.value}
                  key={idx}
                />
              ))
            }
          </motion.ul>
        </div>
      </div>
    </div>
  )
}
